import { IFracGroupWell } from '../../interfaces/ifrac-group-well';
import { FracGroup } from '../frac-group';
import { Well } from '../well';

export class FracGroupWellBase {
  FracGroupWellId: number;
  FracGroupId: number;
  WellId: number;
  AssetTeamId: number;
  SortOrder: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FracGroup?: FracGroup;
  Well?: Well;

  constructor(item?: IFracGroupWell) {
    if (item) {

      this.FracGroupWellId = item.FracGroupWellId;
      this.FracGroupId = item.FracGroupId;
      this.WellId = item.WellId;
      this.AssetTeamId = item.AssetTeamId;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FracGroup = new FracGroup(item.FracGroup);
      this.Well = new Well(item.Well);
    }
  }
}